import { Comment, TwitterResult } from "./types";

export const isTwitterResult = (result: Comment): result is TwitterResult => {
  return 'tweet_id' in result;
};